/**
 * Комбінація клавіш: кожна клавіша — окрема `<kbd>`, символи ОС («⌘», «↩», «↑») мають назву
 * словами для програми читання (рев'ю S4: «⌘» вона читає незрозуміло).
 */
import { chordKeys, type Hotkey, kbdLabel, kbdSpoken, SPOKEN } from '../app/hotkeys.ts';

export function Chord({ keys, className }: { keys: readonly string[]; className?: string }) {
  return (
    <span className={className ? `chord ${className}` : 'chord'}>
      {keys.map((k, i) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: та сама клавіша може повторитись (G G)
        <kbd key={i}>
          {SPOKEN[k] ? (
            <>
              <span aria-hidden="true">{k}</span>
              <span className="sr-only">{SPOKEN[k]}</span>
            </>
          ) : (
            k
          )}
        </kbd>
      ))}
    </span>
  );
}

export const HotkeyChord = ({ hotkey, className }: { hotkey: Hotkey; className?: string }) => (
  <Chord keys={chordKeys(hotkey)} {...(className ? { className } : {})} />
);

/**
 * Підказка комбінації з `Ctrl` / `⌘` однією `<kbd>` (у кнопці «Зберегти ⌘↩»): на екрані — нотація
 * ОС (`kbdLabel`), програмі читання — словами (`kbdSpoken`).
 */
export function ModKbd({ k, className }: { k: string; className?: string }) {
  const label = kbdLabel(k);
  const spoken = kbdSpoken(k);
  return (
    <kbd {...(className ? { className } : {})}>
      {label === spoken ? (
        label
      ) : (
        <>
          <span aria-hidden="true">{label}</span>
          <span className="sr-only">{spoken}</span>
        </>
      )}
    </kbd>
  );
}
